import { render, staticRenderFns } from "./staticData.pug?vue&type=template&id=02bd5e77&scoped=true&lang=pug&"
import script from "./staticData.ts?vue&type=script&lang=ts&"
export * from "./staticData.ts?vue&type=script&lang=ts&"
import style0 from "./staticData.styl?vue&type=style&index=0&id=02bd5e77&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02bd5e77",
  null
  
)

export default component.exports